/**
 * @generated SignedSource<<23db3b3d8e43f831591a80cd6d53ee15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskFooter_viewer$data = {
  readonly zendeskArticles: {
    readonly article?: {
      readonly title: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskFooter_viewer";
};
export type GetHelpZendeskFooter_viewer$key = {
  readonly " $data"?: GetHelpZendeskFooter_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskFooter_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "articleId"
    },
    {
      "kind": "RootArgument",
      "name": "hasArticleId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskFooter_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "condition": "hasArticleId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "articleId",
                  "variableName": "articleId"
                }
              ],
              "concreteType": "ZendeskArticle",
              "kind": "LinkedField",
              "name": "article",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "04835c92d968b63dc60a127d19ad443f";

export default node;
